import { generateId } from '@freelancer/datastore/testing/helpers';
import {
  ExternalCredentialAllocationContextTypeApi,
  ExternalCredentialStatusApi,
} from 'api-typings/external_credentials/external_credentials';
import type {
  AdminExternalCredentialAllocation,
  AdminExternalCredentialAllocationContext,
} from './admin-external-credential-allocations.model';

export interface GenerateAdminExternalCredentialAllocationOptions {
  readonly id?: number;
  readonly userId?: number;
  readonly externalCredentialProviderId?: number;
  readonly credentialStatus?: ExternalCredentialStatusApi;
  readonly externalHandle?: string;
  readonly timeUpdated?: number;
  readonly timeCreated?: number;
  readonly expiryTime?: number;
  readonly contexts?: readonly GenerateAdminExternalCredentialAllocationContextOptions[];
}

export type GenerateAdminExternalCredentialAllocationContextOptions = Readonly<
  Partial<AdminExternalCredentialAllocationContext>
>;

export function generateAdminExternalCredentialAllocationObject({
  id = generateId(),
  userId = generateId(),
  externalCredentialProviderId = generateId(),
  credentialStatus = ExternalCredentialStatusApi.ACTIVE,
  externalHandle = 'test@freelancer.com',
  timeUpdated = Date.now(),
  timeCreated = Date.now(),
  expiryTime = Infinity,
  contexts = [generateAdminExternalCredentialAllocationContextObject({})],
}: GenerateAdminExternalCredentialAllocationOptions): AdminExternalCredentialAllocation {
  return {
    id,
    userId,
    externalCredentialProviderId,
    credentialStatus,
    externalHandle,
    timeUpdated,
    timeCreated,
    expiryTime,
    contexts: contexts.map(
      generateAdminExternalCredentialAllocationContextObject,
    ),
  };
}

export function generateAdminExternalCredentialAllocationContextObject({
  id = generateId(),
  contextId = generateId(),
  contextType = ExternalCredentialAllocationContextTypeApi.PROJECT,
  expiryTime = Infinity,
  threadId = generateId(),
  taskUrl = 'https://www.example.com/login',
}: GenerateAdminExternalCredentialAllocationContextOptions): AdminExternalCredentialAllocationContext {
  return {
    id,
    contextId,
    contextType,
    expiryTime,
    threadId,
    taskUrl,
  };
}

export function projectContext({
  id = generateId(),
  projectId = generateId(),
  threadId = generateId(),
  expiryTime = Date.now() + 1000 * 60 * 60 * 24, // 1 day from now
  taskUrl = 'https://www.example.com/login',
}: {
  readonly id?: number;
  readonly projectId?: number;
  readonly threadId?: number;
  readonly expiryTime?: number;
  readonly taskUrl?: string;
}): AdminExternalCredentialAllocationContext {
  return {
    id,
    contextId: projectId,
    contextType: ExternalCredentialAllocationContextTypeApi.PROJECT,
    threadId,
    expiryTime,
    taskUrl,
  };
}
